import React, { useEffect, useRef } from 'react';
import { VIEWPORTS, setEditorScrollRoot } from '../utils/defaults';

export default function EditorViewportFrame({
  viewMode,
  pageStyle,
  viewportStyle,
  viewportRef,
  children,
}) {
  const scrollRef = useRef(null);
  const isDesktop = viewMode === 'desktop';
  const isMobile = viewMode === 'mobile';
  const isTablet = viewMode === 'tablet';
  const width = isDesktop ? '100%' : `${VIEWPORTS[viewMode]?.width ?? 390}px`;

  useEffect(() => {
    setEditorScrollRoot(scrollRef.current);
    return () => setEditorScrollRoot(null);
  }, [viewMode]);

  return (
    <div
      ref={scrollRef}
      className={`flex-1 overflow-y-auto overflow-x-hidden overscroll-contain ${
        isDesktop ? '' : 'flex justify-center py-8 px-4 bg-neutral-400/25'
      }`}
    >
      <div
        className={`transition-all duration-300 mx-auto ${
          isDesktop
            ? 'w-full min-h-full'
            : 'shrink-0 shadow-2xl bg-neutral-900/90 overflow-visible'
        } ${isMobile ? 'rounded-[2.25rem] p-2' : ''} ${isTablet ? 'rounded-2xl p-3' : ''}`}
        style={isDesktop ? undefined : { width, maxWidth: '100%' }}
      >
        {isMobile && (
          <div className="h-5 flex items-center justify-center mb-1">
            <div className="w-16 h-1 rounded-full bg-neutral-600" aria-hidden />
          </div>
        )}
        <div
          ref={viewportRef}
          className={`w-full bg-white wc-site-viewport wc-site-viewport--${viewMode} ${
            isMobile ? 'rounded-[1.75rem]' : isTablet ? 'rounded-xl' : 'min-h-full'
          }`}
          data-wc-viewport={viewMode}
          style={{
            ...pageStyle,
            ...viewportStyle,
            minHeight: isDesktop ? undefined : undefined,
          }}
        >
          {children}
        </div>
        {isMobile && <div className="h-3" aria-hidden />}
      </div>
    </div>
  );
}
